var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-menu',{attrs:{"offset-y":"","open-on-hover":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({attrs:{"text":""}},'v-btn',attrs,false),on),[_vm._v(" Users ")])]}}])},[_c('v-list',_vm._l((_vm.users),function(user){return _c('v-list-item',{key:user.id,attrs:{"dense":"","to":{name: 'User', params: {id: user.id}}}},[_c('v-list-item-title',[_vm._v(_vm._s(user.name))])],1)}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }